<script lang="ts" setup>
import type { StaticPageVideo } from '~/types/StaticPageList';

defineProps<{ video: StaticPageVideo }>();
</script>

<template>
  <div
    v-if="video.video_mp4"
    class="constructor-video"
  >
    <p
      v-if="video.title"
      class="constructor-video__title"
    >
      {{ video.title }}
    </p>

    <video
      :poster="video.banner"
      :src="video.video_mp4"
      class="constructor-video__video"
      controls
    >
      Похоже что ваш браузер не поддерживает воспроизведение видео. Вы можете его
      <a :href="video.video_mp4">скачать</a> и попробовать воспроизвести на устройстве.
    </video>
  </div>
</template>

<style lang="scss" scoped>
.constructor-video {
  width: 100%;

  &__title {
    margin-bottom: 12px;
    color: $hell-black;
    font-weight: $bold;
  }

  &__video {
    object-fit: contain;
    overflow: hidden;
    width: 100%;
    height: auto;
    border-radius: 12px;
    aspect-ratio: 16/9;
  }
}
</style>
